import { ChevronLeft } from 'lucide-react';
import Logo from '@/assets/login_logo.svg';
import XLogo from '@/assets/member-assets/homepage/x_logo.svg';
import { SidebarMode, getAvailableSidebarModes } from '@/config/sidebar-config';
import { cn } from '@/lib/utils';

interface SidebarLogoProps {
  sidebarMode: SidebarMode;
  onToggle: () => void;
  testIdPrefix?: string;
}

export const SidebarLogo = ({ sidebarMode, onToggle, testIdPrefix }: SidebarLogoProps) => {
  const hasMultipleModes = getAvailableSidebarModes().length > 1;
  const isCollapsed = sidebarMode === 'icon-only';
  const isCompact = sidebarMode === 'compact';

  return (
    <div
      className={cn(
        'shrink-0 p-4 border-b border-white/10 h-[65px] flex items-center',
        isCollapsed || isCompact ? 'justify-center' : 'justify-between'
      )}
      data-testid={testIdPrefix ? `${testIdPrefix}_logoSection` : undefined}
    >
      <button
        type="button"
        onClick={hasMultipleModes ? onToggle : undefined}
        title={hasMultipleModes ? 'Switch sidebar mode' : undefined}
        aria-label={hasMultipleModes ? 'Switch sidebar mode' : 'PMX Health'}
        className={!hasMultipleModes ? 'cursor-default' : undefined}
        data-testid={testIdPrefix ? `${testIdPrefix}_logoToggleBtn` : undefined}
      >
        <img
          src={isCollapsed || isCompact ? XLogo : Logo}
          alt="Logo"
          className={cn('h-8 brightness-0 invert', isCompact && 'h-6')}
        />
      </button>
      {sidebarMode === 'full' && hasMultipleModes && (
        <button
          type="button"
          onClick={onToggle}
          className="p-1.5 hover:bg-white/10 rounded-lg transition-colors duration-150 ease motion-reduce:transition-none"
          title="Collapse sidebar"
          aria-label="Collapse sidebar"
          data-testid={testIdPrefix ? `${testIdPrefix}_collapseSidebarBtn` : undefined}
        >
          <ChevronLeft className="h-5 w-5 text-white/60" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};
